import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { pick, get, find } from 'lodash';
import EstimatedPayment from '../../components/commit-form/estimated-payment';
import Purchase from '../../lib/purchase';
import { COMMIT_NAMESPACE } from '../../actions';
import { Money } from '../../lib/money';

class EstimatedPaymentContainer extends Component {
  render() {
    if (!this.props.multiPayment) return null;
    const props = pick(this.props, ['amount', 'title']);
    return <EstimatedPayment {...props} />;
  }
}

const mapStateToProps = ({ memberships, purchases, projections }) => {
  const membership = get(projections, `${COMMIT_NAMESPACE}.memberships.${memberships.current}`);
  const purchase = purchases.byId[purchases.current];
  const { currentPayment: { id: paymentId, number } } = purchase;

  if (!membership) return {};

  const contribution = find(membership.contributions, cont => cont.paymentId === paymentId);
  const amount = get(contribution, 'amount', Money.zero(purchase.currencyCode));
  const title = number > 1 ?
    <FormattedMessage
       id="estimatedPayment.nextPayment"
       defaultMessage="Estimated next payment"
     /> :
     <FormattedMessage
       id="estimatedPayment.firstPayment"
       defaultMessage="Estimated first payment"
     />;

  return {
    amount,
    title,
    multiPayment: Purchase.isMultiPayment(purchase.payments),
  };
};


export default connect(mapStateToProps)(EstimatedPaymentContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/estimated-payment.container.js